import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../CSS/general.css";
import JobList from "./JobList";
import JobHistory from "./JobHistory";
import JobDetail from "./JobDetail";
import Repositories from "./Repositories";
import Eventlogs from "./Eventlogs";

import Overview from "./Overview";
import Axios from "axios";
import { API_ROUTE, Routes, Urls } from "../../Helpers/Constants";
import { NavBar } from "../NavBar";
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from "react-loading-overlay";
import AuthenticationContext from "../../Store/Authentication-Context";
import Modal from 'react-bootstrap/Modal';
import Arrow from '../../images/Arrow.png';
import LoaderGif from "../../images/365 loading.gif";
LoadingOverlay.propTypes = undefined;
const urlParams = new URLSearchParams(window.location.search);
export class MainComp extends Component {
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);

        let guardianOnlyCheck = (sessionStorage.getItem('GuardianOnlyEnabled-' + new URLSearchParams(window.location.search).get("orgId")).toString() === "true");

        this.state = {
            orgId: urlParams.get("orgId") ,
            orgName: urlParams.get("orgName"),
            token: "",
            jobSessionUrl: "",
            jobLogUrl: "",
            org: [],
            repositories: [],
            jobsUrl: "",
            baseUrl: Urls.SERVER_PATH,
            refresh: true,
            isLoading: false,
            priceModal: {},
            totalUserCount: "",
            showErrorPage: false,
            effectiveDate: "",
            currentStatus: "",
            trailUntil: "",
            guardianStatusLoaded: false,
            isAzureGuardianOnly: guardianOnlyCheck,
            isAzureGuardianOnlyLoaded: true,
            activeTab: "365",
            azureRepo: [],
            directDebitUrl: "",
            entraJobId:""
        };
        this.initialLoad = this.initialLoad.bind(this);
        this.getDirectDebitUrl = this.getDirectDebitUrl.bind(this);
        this.reloadRepository = this.reloadRepository.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.listAzureBucket = this.listAzureBucket.bind(this);
    }
   
    openModal = () => this.setState({
        isOpen
            : true
    });
    closeModal = () => this.setState({ isOpen: false });



    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        this.setState({ orgId: urlParams.get("orgId") });
         this.initialLoad();
        this.getDirectDebitUrl();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.priceModal !== prevState.priceModal) {
            if (this.state.priceModal && Object.keys(this.state.priceModal).length !== 0 && this.state.priceModal.features.find(feature => feature.featureType === "AZURE") !== undefined && this.state.priceModal.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") {
                if (this.state.org?.name) {
                    this.listAzureBucket();
                }
            }
            
        }
    }
    async listAzureBucket() {
        const { setAuthContext } = this.context;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let AzureBucketList = await Axios.get(API_ROUTE + Routes.GET_AZURE_BUCKET_LIST + "/" + this.state.orgId + "/" + this.state.org.name, config)
            .then((response) => {
                let isAzureand365 = JSON.parse(response.data);
                return isAzureand365;

            })
            .catch((reason) => {
                console.log("catch Repo ; " + reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        if (AzureBucketList) {
            this.setState(
                {
                    azureRepo: [AzureBucketList],
                }
            );
        }
        
    }
    async getDirectDebitUrl() {
        const { setAuthContext } = this.context;

        try {

            const tokenString = await setAuthContext(new Date());
            const cloudCoverToken = sessionStorage.getItem('CloudCoverToken');

            const config = {
                headers: {
                    Authorisation: `Bearer ${tokenString}`,
                    CloudCoverToken: cloudCoverToken,
                },
            };

            const settingsResponse = await Axios.get(API_ROUTE + Routes.GET_NAVBAR_SETTINGS, config);
            const settings = settingsResponse.data;
            const config1 = {
                headers: {
                    Authorisation: `Bearer ${tokenString}`,
                    CloudCoverToken: cloudCoverToken,
                },
            };
            //if (settings.isReseller || settings.isDirectCustomer) {
                const pricingResponse = await Axios.get(
                    API_ROUTE + Routes.PRICING_MODEL_ID + "/" + this.state.orgId + "/dummyValue",
                    config1
                );

                const pricingData = pricingResponse.data;
                if (!pricingData || pricingData === "Failed") return;

                const selectItems = JSON.parse(pricingData);

                const configs = {
                    headers: {
                        Authorisation: `Bearer ${tokenString}`,
                        CloudCoverToken: cloudCoverToken,
                    },
                };

                const orgStatusResponse = await Axios.get(
                    API_ROUTE + Routes.GET_ORG_STATUS + "/" + this.state.orgId,
                    configs
                );

                const orgStatus = orgStatusResponse.data;
                const isManaged = this.state.orgId !== sessionStorage.getItem("orgId");

                //if (settings.isReseller || settings.isDirectCustomer)
                    this.setState({
                        directDebitUrl: `/ContractCommit?signkey=${this.state.orgId}&reseller=${settings.isReseller}&directCustomer=${settings.isDirectCustomer}&status=${orgStatus.status}&userPrice=${orgStatus.userPrice}&priceName=${selectItems.price.name}&quotaValue=${orgStatus.quotaValue}&termValue=${orgStatus.termValue}&isManaged=${isManaged}`,
                    });
                //console.log(this.state.directDebitUrl)
        //    }
        }
        catch (error) {
            console.error("Error:", error);

            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
        
    }

    async initialLoad(event) {
        if (event) {
            event.preventDefault();
        }
        //var token = await loginAuthProvider.getAccessToken();
        //var tokenString = token.accessToken;

        const { setAuthContext } = this.context;
        var tokenString = await setAuthContext(new Date());
        this.setState({ token: tokenString, });
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let data = await Axios.get(API_ROUTE + Routes.GET_ORG + "/" + urlParams.get("orgId"), config)
            .then((response) => {
              

                let selectItems = JSON.parse(response.data);
                return selectItems;
            })
            .catch((reason) => {
                console.log("catch Org" + reason);
                this.setState(
                    {
                        showErrorPage: true,
                    }
                );
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        if (data) {
            
            this.setState(
                {
                    org: data,
                }
            );
        }

        //let payload = {
        //    url: "/v7/Organizations/" + this.state.orgId + "/Users",
        //    orgId: this.state.orgId,
        //};
        //const dataNew = await Axios.get(API_ROUTE + Routes.TENANT_USER_COUNT + "/" + this.state.orgId, config)
        //    .then((response) => {

        //        if (response.data)
        //            this.setState({ totalUserCount: response.data })
        //        return JSON.parse(response.data);
        //    })
        //    .catch((reason) => {
        //        //closeAlertModal(reason.message);
        //        //params.hideOverlay();
        //    });

        
        const { setRepoData, checkDataForId, RepoData } = this.context;
        const isRepoAvailable = await checkDataForId(this.state.orgId);
        let repoData;
        if (isRepoAvailable) {
            repoData=RepoData[this.state.orgId];
        }
        else {
            repoData = await Axios.get(API_ROUTE + Routes.GET_REPO + "/" + this.state.orgId , config)
                .then((response) => {
                    let selectItems = JSON.parse(response.data);
                    setRepoData({ id: this.state.orgId, data: selectItems });
                    return selectItems;

                })
                .catch((reason) => {
                    console.log("catch Repo ; " + reason);
                    this.setState(
                        {
                            showErrorPage: true,
                        }
                    );
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }
        if (repoData) {
            this.setState(
                {
                    repositories: repoData,
                }
            );
        }
       
      
       
        await Axios.get(API_ROUTE + Routes.GET_ORG_SETTINGS + '/' + this.state.orgId, config)
            .then((response) => {

                if (response.data) {

                    if (response.data && response.data.effectiveDate)
                        this.setState({ effectiveDate: response.data.effectiveDate });

                    if (response.data.trialUntil) {
                        const dateStr = response.data.trialUntil;
                        const normalizedDateStr = dateStr.split(' ')[0].replace(/-/g, '/');
                        const [day, month, year] = normalizedDateStr.split('/');
                        const givenDate = new Date(`${year}-${month}-${day}`);
                        givenDate.setHours(0, 0, 0, 0);
                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0);
                        const diffTime = givenDate - currentDate;
                        const daysDifference = Math.round(diffTime / (1000 * 60 * 60 * 24));
                        this.setState({ trailUntil: daysDifference });
                        this.setState({ trialDate: response.data.trialUntil });
                    }
                    if (response.data.creationDate) {
                        this.setState({ creationDate: response.data.creationDate });
                    }

                    if (response.data.currentStatus) {
                        this.setState({ currentStatus: response.data.currentStatus });
                    }
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        
        
        let ModelUserName = "NA";
        if (sessionStorage.UserName) {
            ModelUserName = sessionStorage.UserName;
        }
        let priceingModalData = await Axios.get(API_ROUTE + Routes.PRICING_MODEL_ID + "/" + this.state.orgId + "/" + ModelUserName, config)
            .then((response) => {
                let selectItems = JSON.parse(response.data);
                return selectItems;

            })
            .catch((reason) => {
                console.log("catch Repo ; " + reason);
                this.setState(
                    {
                        showErrorPage: true,
                    }
                );
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        if (priceingModalData) {
            this.setState(
                {
                    priceModal: priceingModalData,
                    guardianStatusLoaded: true,
                }
            );
        }
    }

    async reloadRepository() 
    {
        //var token = await loginAuthProvider.getAccessToken();
        //var tokenString = token.accessToken;
        const { setAuthContext } = this.context;
        var tokenString = await setAuthContext(new Date());
        this.setState({ token: tokenString, });
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let repoData = await Axios.get(API_ROUTE + Routes.GET_REPO + "/" + this.state.orgId , config)
            .then((response) => {
                let selectItems = JSON.parse(response.data);
                return selectItems;

            })
            .catch((reason) => {
                console.log("catch Repo ; " + reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        if (repoData) {
            this.setState(
                {
                    repositories: repoData,
                }
            );
        }
       
     
    }
    handleGoBack = () => {
        //window.history.back(); 
        this.handleErrorShow();
    };

    handleErrorClose = () => this.setState(
        {
            showErrorPage: false,
        }
    );
    handleErrorShow = () => this.setState(
        {
            showErrorPage: true,
        }
    );
    setActiveTab = (activeTab) => {
        this.setState({ activeTab: activeTab });
    };
    render() {
        const jobSessionSelected = (url) => {
            this.setState({ jobLogUrl: url });
        }

        const setIsLoading = (params) => {
            this.setState({ isLoading: params });
        };

        const reloadStateRepository = (params) => {
            this.reloadRepository();
            
        };

        const jobSelected = (url) => {
            this.setState({ refresh: "" });
            this.setState({ jobSessionUrl: url });
            this.setState({ jobLogUrl: "" });
        }
        const entraJobSelected = (id) => {
            this.setState({ entraJobId: id });
        }
        const refreshData = () => {
            this.setState(refreshState => ({ refresh: !refreshState.refresh }));
        }
        let mainSection = (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<img src={LoaderGif} alt="Loading..." style={{ width: '50px', height: '50px' }} />}
                text="Loading your content..."
            >
                {
                    
                    <div>
                        {this.state.showErrorPage &&
                            <>
                            <Modal show={this.state.showErrorPage} onHide={this.handleErrorClose} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Error</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Oops! Something went wrong.<br></br>

                                    Please contact our support team for assistance.<br></br>

                                </Modal.Body>
                                
                            </Modal>
                            <img className="neonArrow" style={{ position: 'fixed', zIndex: '10002', width: '9%', bottom: '0vh', right: '10vw' }} src={Arrow} alt="Arrow" />
                        </>
                        }

                        <NavBar page="main" authContext={this.context} isAzureGuardianOnly={this.state.isAzureGuardianOnly} />
                        <div className="row p-0 me-1" style={{ maxHeight: '92vh', overflowY: 'auto', overflowX: 'hidden' }}>
                            <div className="col-md-12 col-xl-8 ms-2 pe-1 mb-2">
                                <JobList jobsUrl={(this.state.org.length < 1) ? "" : this.state.org._links.jobs.href} orgDetails={this.state.org} token={this.state.token} jobSelected={jobSelected} entraJobSelected={entraJobSelected} refresh={refreshData} repositories={this.state.repositories} isLoading={setIsLoading} reloadRepositories={reloadStateRepository} guardianStatusLoaded={(this.state.guardianStatusLoaded) ? this.state.priceModal : false} priceModel={(this.state.priceModal) ? this.state.priceModal : "{}"} actualOrgUserCount={(this.state.repositories.OrgUserCount) ? this.state.repositories.OrgUserCount : "0"} isAzureGuardianOnly={this.state.isAzureGuardianOnly} isAzureGuardianOnlyLoaded={this.state.isAzureGuardianOnlyLoaded} setActiveTab={this.setActiveTab} />
                                <JobHistory jobSessionUrl={this.state.jobSessionUrl} entraJobId={this.state.entraJobId } token={this.state.token} jobSessionSelected={jobSessionSelected} refresh={this.state.refresh} isAzureGuardianOnly={this.state.isAzureGuardianOnly} activeTab={ this.state.activeTab} />
                                <JobDetail jobLogUrl={this.state.jobLogUrl} token={this.state.token} refresh={this.state.refresh} isAzureGuardianOnly={this.state.isAzureGuardianOnly} activeTab={this.state.activeTab} />
                            </div>
                            <div className="col col-sm ps-1 pe-0">
                                <Overview org={this.state.org} orgName={this.state.orgName} diskSpace={(this.state.repositories.TotalSpace) ? this.state.repositories.TotalSpace : ""} userCount={(this.state.repositories.UserCount) ? this.state.repositories.UserCount : ""} priceModel={(this.state.priceModal) ? this.state.priceModal : {}} actualOrgUserCount={(this.state.repositories.OrgUserCount) ? this.state.repositories.OrgUserCount : ""} orgUserCount={this.state.totalUserCount} repositories={(this.state.repositories.Repositories) ? this.state.repositories.Repositories : {}} effectiveDate={this.state.effectiveDate} currentStatus={this.state.currentStatus} isAzureGuardianOnly={this.state.isAzureGuardianOnly} activeTab={this.state.activeTab} creationDate={this.state.creationDate} trialDate={this.state.trialDate} trailUntil={this.state.trailUntil} url={this.state.directDebitUrl} orgId={this.state.orgId} />
                                <Repositories repositories={this.state.repositories} baseUrl={this.state.baseUrl} orgId={this.state.orgId} orgName={this.state.org.name} priceModel={(this.state.priceModal) ? this.state.priceModal : "{}"} isAzureGuardianOnly={this.state.isAzureGuardianOnly} activeTab={this.state.activeTab} azureRepo={this.state.azureRepo} />
                                <Eventlogs orgId={this.state.orgId} />
                            </div>
                        </div>
                            
                        
                    </div>
                }
                </LoadingOverlay>

        );
        return (
            <React.Fragment>
                {mainSection}
            </React.Fragment>

        );
    }
}